import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContentAuthoringService } from 'src/app/services/content-authoring.service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-organisation-create',
  templateUrl: './organisation-create.component.html',
  styleUrls: ['./organisation-create.component.scss']
})
export class OrganisationCreateComponent implements OnInit {
  adminData: any; org_error: any = '';
  errorInfo: { isError: boolean, errorMsg: string } = { isError: false, errorMsg: '' }
  is_active = '1';
  organisationData: any;
  submitted = false;
  userData = "";
  status: any = '';
  id: any = '';

  constructor(private contentAuthoringApi: ContentAuthoringService,
    private route: ActivatedRoute,
    private router: Router, private spinner: NgxSpinnerService) {
    // if (localStorage.getItem('adminData') =='' || localStorage.getItem('adminData') == null) {
    //  this.router.navigateByUrl('/admin-login');
    //}
  }
  orgForm = new FormGroup({

    organisation_name: new FormControl('', [Validators.required]),
    organisation_type: new FormControl('', [Validators.required]),
    validity: new FormControl('', [Validators.required]),
    organisation_id: new FormControl(''),
  });
  get f() { return this.orgForm.controls; }

  validity = [
    {value: 1, viewValue: "1 Month"},
    {value: 2, viewValue: "2 Month"},
    {value: 3, viewValue: "3 Month"},
    {value: 4, viewValue: "4 Month"},
    {value: 5, viewValue: "5 Month"},
    {value: 6, viewValue: "6 Month"},
    {value: 7, viewValue: "8 Month"},
    {value: 9, viewValue: "9 Month"},
    {value: 10, viewValue: "10 Month"},
    {value: 11, viewValue: "11 Month"},
    {value: 12, viewValue: "12 Month"},
    {value: 13, viewValue: "13 Month"},
    {value: 14, viewValue: "14 Month"},
    {value: 15, viewValue: "15 Month"},
    {value: 16, viewValue: "16 Month"},
    {value: 17, viewValue: "17 Month"},
    {value: 18, viewValue: "18 Month"},
    {value: 19, viewValue: "19 Month"},
    {value: 20, viewValue: "20 Month"},
    {value: 21, viewValue: "21 Month"},
    {value: 22, viewValue: "22 Month"},
    {value: 23, viewValue: "23 Month"},
    {value: 24, viewValue: "24 Month"},
  ];

  ngOnInit(): void {
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
    this.route.queryParams.subscribe(params => {
      const Org_id = +params.id;
      this.id = +params.id;
      this.status = +params.type;
      this.getDetail(Org_id);
     // this.editOrg(Org_id);
    });
  }
  getDetail(Org_id:any){
    this.contentAuthoringApi.detailOrg(Org_id).subscribe(
      (data) => {
        console.log(  this.adminData);
       this.orgForm.patchValue({ "organisation_name": data.org_data[0].org_name });
       this.orgForm.patchValue({ "organisation_type": data.org_data[0].org_type.toString() });
       this.orgForm.patchValue({ "validity": data.org_data[0].account_validity});
       this.orgForm.patchValue({ "organisation_id": data.org_data[0].organisation_id });
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }
  editOrg(orgForm: any) {
   // console.log(this.orgForm.value);
   // console.log(  this.adminData);
    this.contentAuthoringApi.editOrg(this.id, this.orgForm.value.organisation_name, this.orgForm.value.organisation_type,this.orgForm.value.validity, this.adminData.user_id).subscribe(
      (data) => {
        if (data.status == 201 || data.status == 200) {
          this.spinner.hide();
          this.userData = JSON.stringify(data.data)
          this.router.navigateByUrl('/organization_successfully');
        }
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }

  /******create organisation *****/
  createOrgUser(orgForm: any) {
    this.spinner.show();
    this.submitted = true;

    if (this.orgForm.invalid) { this.spinner.hide(); return; }
   // console.log(this.orgForm)
    this.contentAuthoringApi.createOrgUser(this.orgForm.value).subscribe(
      (data) => {
        console.log(data);
        if (data.status == 201 || data.status == 200) {
          this.spinner.hide();
          // localStorage.setItem('userData', JSON.stringify(data.data));
          this.userData = JSON.stringify(data.data)
          this.router.navigateByUrl('/organization_successfully');
        } else if (data.org_error) {
          this.spinner.hide();
          this.org_error = data.org_error;
        } else {
          this.spinner.hide();
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'Something went wrong';
        }
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }

  logout() {
    // localStorage.clear();
    localStorage.removeItem('adminLoginPass');
    localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
  }
}
